import { render, staticRenderFns } from "./StudentPreRegistrationTable.vue?vue&type=template&id=ac24efda&scoped=true"
import script from "./StudentPreRegistrationTable.vue?vue&type=script&lang=js"
export * from "./StudentPreRegistrationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac24efda",
  null
  
)

export default component.exports